@import '@hevoio/hevo-ui-toolkit/styles/variables';

.editorWrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 300px;
  overflow: hidden;
  &.autoHeight {
    height: auto;
  }
}

.editor {
  overflow: hidden;
  flex: 1;
  width: 100%;
  z-index: 1;
}

.floatingActions {
  position: absolute;
  right: $spacer;
  top: $spacer * 0.5;
  z-index: 2;
}

.floatingAction + .floatingAction {
  margin-top: $spacer;
}

.resizeCtrlV {
  flex-shrink: 0;
  background: $surface-bg-alternate;
  border-top: solid $border-width $divider-color;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: row-resize;
}
